module.exports = __webpack_public_path__ + "static/media/viewtablemappings.134eb2e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/viewtablemappings.png
// module id = 1862
// module chunks = 193